/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSurfboardCuteFi: {
  name: 'surfboard-cute-fi';
  data: string;
} = {
  name: 'surfboard-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.56 3.744c-1.104.094-1.684.186-2.632.417-3.243.79-6.172 2.462-8.284 4.731-1.704 1.829-3.078 4.087-3.862 6.346-.438 1.262-.303 2.377.413 3.411.254.366 1.852 1.958 2.2 2.19.933.624 2.034.794 3.08.474.453-.138 1.559-.589 2.145-.875 2.242-1.094 4.331-2.705 5.806-4.476 1.977-2.375 3.374-5.625 3.757-8.742.093-.757.096-1.828.005-2.191-.163-.654-.514-1.021-1.143-1.196-.263-.074-1.09-.123-1.485-.089"/></svg>`
};
